/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на создание заявления на услугу информирования по счетам
 */
export interface ApplicationCreate {
  /** Признак создания документа */
  isDraft?: boolean;

  /** Номер счета для списания комиссии за услугу */
  accountCharge?: string;

  /** Тип заявки */
  requestType?: string;

  /** Признак создания документа */
  contacts?: ContactCFT[];
}

/**
 * Контакты в ЦФТ
 */
export interface ContactCFT {
  /** Идентификатор контакта в ЦФТ */
  contactId?: string;

  /** Статус подключения или действие над подключением */
  statusCode?: string;

  /** Имя ответственного лица, кому будут отсылаться СМС */
  fullName?: string;

  /** Фамилия контактного лица - получателя СМС */
  lastName?: string;

  /** Имя контактного лица - получателя СМС */
  firstName?: string;

  /** Отчество контактного лица - получателя СМС */
  middleName?: string;

  /** Номер телефона, на который будут отправляться СМС. */
  phoneNumber?: string;

  /** Список счетов, изменения по остаткам которых будут отправляться в СМС на данный контакт */
  accountList?: string[];
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Запрос на обновление статуса заявления
 */
export interface ApplicationUpdate {
  /**
   * Идентификатор заявления
   * @format uuid
   */
  id?: string;

  /** Статус заявления */
  state?: string;
}

export interface AccountHistory {
  /**
   * Номер счета
   * @example accountNum
   */
  accountNum?: string;
}

/**
 * Объект заявлений пользователя
 */
export interface ApplicationHistory {
  /**
   * ID заявления
   * @format uuid
   */
  id?: string;

  /** Номер счёта для списания комиссии за услугу */
  accountCharge?: string;

  /** Тип заявки. Что делаем с услугой */
  requestType?: string;

  /** Статус заявления */
  state?: string;

  /**
   * Дата создания заявления
   * @format date-time
   * @example 2023-09-06T14:30:00Z
   */
  createDate?: string;

  /**
   * ID клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Тип документа. Константа
   * @example Заявление на услугу информирования
   */
  documentType?: string;

  /** Список подключаемых контактов */
  contacts?: ContactHistory[];

  /** Список привилегий пользователя */
  permissions?: Permission[];
}

/**
 * История заявлений
 */
export interface ApplicationHistoryResponse {
  /** Пагинация данных */
  resultPage?: ResultPage;

  /** Список заявлений */
  applicationHistory?: ApplicationHistory[];
}

/**
 * Список подключаемых контактов
 */
export interface ContactHistory {
  /**
   * ID контакта
   * @format uuid
   */
  id?: string;

  /**
   * ID заявки
   * @format uuid
   */
  requestId?: string;

  /**
   * Статус контакта
   * @example statusCode
   */
  statusCode?: string;

  /**
   * Имя ответственного лица, кому будут отсылаться СМС
   * @example fullName
   */
  fullName?: string;

  /**
   * Номер телефона, на который будет отправляться СМС
   * @example phoneNumber
   */
  phoneNumber?: string;

  /**
   * Список счетов, изменения по остаткам которых
   * @example accountList
   */
  accountList?: AccountHistory[];
}

/**
 * Привилегии пользователя
 */
export interface Permission {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Пагинация данных
 */
export interface ResultPage {
  /** Есть ли ещё страницы */
  hasMore?: boolean;

  /**
   * Текущая страница
   * @format int32
   */
  pageNumber?: number;

  /**
   * Количество записей на странице
   * @format int32
   */
  pageSize?: number;
}

/**
 * Объект заявлений пользователя
 */
export interface ApplicationDetail {
  /**
   * ID заявления
   * @format uuid
   */
  id?: string;

  /** Номер счёта для списания комиссии за услугу */
  accountCharge?: string;

  /** Тип заявки. Что делаем с услугой */
  requestType?: string;

  /** Статус заявления */
  state?: string;

  /** Наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientINN?: string;

  /** Причина перевода в статус REQUIRED_CHANGE */
  error?: ErrorDetail;

  /** Список подключаемых контактов */
  contacts?: ContactDetail[];

  /** Список привилегий пользователя */
  permissions?: Permission[];
}

/**
 * Список подключаемых контактов
 */
export interface ContactDetail {
  /** @format uuid */
  id?: string;
  contactId?: string;
  statusCode?: string;
  fullName?: string;
  phoneNumber?: string;
  accountList?: AccountHistory[];
}

/**
 * Причина перевода в статус REQUIRED_CHANGE
 */
export interface ErrorDetail {
  errorCode?: string;
  errorDesc?: string;
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: Permission[];
}

/**
 * Список счетов, СМС-информирование по которым подключено к данному контакту
 * @example accountList
 */
export interface AccountInfo {
  /**
   * Номер счета
   * @example accountNum
   */
  accountNum?: string;

  /**
   * Признак подключения
   * @example false
   */
  isSignConnect?: boolean;
}

export interface ConnectionInfo {
  /** Информация о текущем подключении СМС -информирования */
  service?: Service;

  /** Информация о тарифе  */
  tariff?: Tariff;
}

/**
 * Список контактов, подключенных к услуге
 */
export interface Contact {
  /**
   * Идентификатор контакта в Мастер-системе
   * @example contactId
   */
  contactId?: string;

  /**
   * Имя ответственного лица, кому приходят СМС
   * @example fullName
   */
  fullName?: string;

  /**
   * Номер телефона, подключенного к услуге
   * @example phoneNumber
   */
  phoneNumber?: string;

  /**
   * Статус контакта
   * @example contactState
   */
  contactState?: string;

  /**
   * Список счетов, СМС-информирование по которым подключено к данному контакту
   * @example accountList
   */
  accountList?: AccountInfo[];
}

/**
 * Информация о текущем подключении СМС -информирования
 */
export interface Service {
  /**
   * Идентификатор информации об услуге в МС
   * @format uuid
   */
  id?: string;

  /** Статус подключения услуги */
  state?: string;

  /**
   * Дата присвоения услуге текущего статуса
   * @format date-time
   */
  startDate?: string;

  /** Счет списания комиссии за пользование услугой */
  accountCharge?: string;

  /** Список контактов, подключенных к услуге */
  contacts?: Contact[];
}

/**
 * Информация о тарифе
 */
export interface Tariff {
  /** Сумма тарифа */
  amount?: number;

  /**
   * Валюта тарифа
   * @example currCode
   */
  currCode?: string;
}

export interface Delegate {
  /**
   * UUID уполномоченного лица
   * @format uuid
   */
  id?: string;

  /** ФИО уполномоченного лица */
  fullName?: string;

  /** Телефон уполномоченного лица */
  phone?: string;
}

export interface ApplicationAccount {
  /** @format uuid */
  id?: string;
  accountNumber?: string;
}

export interface ApplicationCcb {
  /** @format uuid */
  id?: string;
  requestType?: string;
  clientInn?: string;
  clientKpp?: string;
  branchCode?: string;
  accountCharge?: string;

  /** @format date-time */
  createDate?: string;
  contacts?: ApplicationContactDto[];
}

export interface ApplicationContactDto {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  requestId?: string;
  extContactId?: string;
  statusCode?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  accounts?: ApplicationAccount[];
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = ApplicationCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

export interface Account {
  /**
   * ID счета
   * @format uuid
   */
  id?: string;

  /**
   * Состояние счета
   * @example state
   */
  state?: string;

  /**
   * Наименование счета
   * @example name
   */
  name?: string;

  /**
   * Валюта счета
   * @example currency
   */
  currency?: string;

  /**
   * Номер счета
   * @example number
   */
  number?: string;

  /**
   * Тип счета
   * @example type
   */
  type?: string;

  /**
   * Дата открытия счета
   * @format date
   */
  openDate?: string;
}

export interface UpdateParams {
  isDraft: boolean;
  id: string;
}

export interface UpdateStatusParams {
  /** @format uuid */
  id: string;
}

export interface SendParams {
  /** @format uuid */
  id: string;
}

export interface GetApplicationHistoryParams {
  /** @format int32 */
  position: number;

  /** @format int32 */
  size: number;
}

export interface PrintParams {
  /** @format uuid */
  id: string;
}

export interface GetConnectionInfoParams {
  fullcontacts?: boolean;
}

export interface GetOrderCcbParams {
  documentId: string;
  documentType: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис 'Управление Информированием'
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-inform-management.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Управление Информированием (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=199493592)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name GetOne
     * @summary Получение информации о заявлении на услугу информирования по счетам
     * @request GET:/api/inform-management/v1/external/requestinform/{id}
     * @secure
     */
    getOne: (id: string, params: RequestParams = {}) =>
      this.request<ApplicationDetail, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name Update
     * @summary Редактирование заявления
     * @request PUT:/api/inform-management/v1/external/requestinform/{id}
     * @secure
     */
    update: (
      { id, ...query }: UpdateParams,
      data: ApplicationCreate,
      params: RequestParams = {}
    ) =>
      this.request<string, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name Delete
     * @summary Удаление заявления
     * @request DELETE:/api/inform-management/v1/external/requestinform/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<string, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name UpdateStatus
     * @summary Обновление статуса заявления
     * @request POST:/api/inform-management/v1/external/requestinform/update-status
     * @secure
     */
    updateStatus: (query: UpdateStatusParams, params: RequestParams = {}) =>
      this.request<ApplicationUpdate, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/update-status`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name Send
     * @summary Отправка подписанного заявления в Банк
     * @request POST:/api/inform-management/v1/external/requestinform/send
     * @secure
     */
    send: (query: SendParams, params: RequestParams = {}) =>
      this.request<ApplicationUpdate, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/send`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name Create
     * @summary Создание заявления на услугу информирования по счетам
     * @request POST:/api/inform-management/v1/external/requestinform/reg
     * @secure
     */
    create: (data: ApplicationCreate, params: RequestParams = {}) =>
      this.request<string, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform/reg`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление
     * @name GetApplicationHistory
     * @summary Получение списка заявлений на услугу информирования по счетам
     * @request GET:/api/inform-management/v1/external/requestinform
     * @secure
     */
    getApplicationHistory: (
      query: GetApplicationHistoryParams,
      params: RequestParams = {}
    ) =>
      this.request<ApplicationHistoryResponse, void | GenericError>({
        path: `/api/inform-management/v1/external/requestinform`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Печатная форма заявления
     * @name Print
     * @summary Получение печатной формы заявления на услугу информирования
     * @request GET:/api/inform-management/v1/external/requestinform/print
     * @secure
     */
    print: (query: PrintParams, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/inform-management/v1/external/requestinform/print`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Заявление.
     * @name GetObtainingDocumentPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/inform-management/v1/external/permissions/{entityStrId}
     * @secure
     */
    getObtainingDocumentPermissions: (
      entityStrId: string,
      params: RequestParams = {}
    ) =>
      this.request<PermissionListResponse, void>({
        path: `/api/inform-management/v1/external/permissions/${entityStrId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование.Услуга
     * @name GetConnectionInfo
     * @summary Получение информации о подключении
     * @request GET:/api/inform-management/v1/external/infoservice
     * @secure
     */
    getConnectionInfo: (
      query: GetConnectionInfoParams,
      params: RequestParams = {}
    ) =>
      this.request<ConnectionInfo, void | GenericError>({
        path: `/api/inform-management/v1/external/infoservice`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Уполномоченные лица
     * @name GetAllClientDelegates
     * @summary Получение списка уполномоченных лиц клиента для подключения услуги
     * @request GET:/api/inform-management/v1/external/delegates
     * @secure
     */
    getAllClientDelegates: (params: RequestParams = {}) =>
      this.request<Delegate[], GenericError>({
        path: `/api/inform-management/v1/external/delegates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подтверждение
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/inform-management/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (query: GetOrderCcbParams, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, void>({
        path: `/api/inform-management/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подтверждение
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/inform-management/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, void>({
        path: `/api/inform-management/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс управления сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/inform-management/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, void>({
        path: `/api/inform-management/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информирование. Счета
     * @name GetOpenedAccounts
     * @summary Получение списка открытых счетов
     * @request GET:/api/inform-management/v1/external/accounts
     * @secure
     */
    getOpenedAccounts: (params: RequestParams = {}) =>
      this.request<Account[], GenericError>({
        path: `/api/inform-management/v1/external/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
